import { render, staticRenderFns } from "./DistanceIcon.vue?vue&type=template&id=53afb83d&scoped=true&"
import script from "./DistanceIcon.vue?vue&type=script&lang=js&"
export * from "./DistanceIcon.vue?vue&type=script&lang=js&"
import style0 from "./DistanceIcon.vue?vue&type=style&index=0&id=53afb83d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53afb83d",
  null
  
)

export default component.exports